const getCategoryId = category => category?.id || category?.slug || null;

export const filterCategoriesByVisibility = (categories = [], visibility = {}) => {
  const { counts = {}, loaded = false } = visibility || {};

  if (!loaded) {
    return categories;
  }

  const filterTree = nodes => {
    return (nodes || []).reduce((visibleNodes, node) => {
      const categoryId = getCategoryId(node);
      const subcategories = Array.isArray(node?.subcategories) ? filterTree(node.subcategories) : [];
      const count = categoryId ? Number(counts[categoryId] || 0) : 0;
      const hasVisibleDescendants = subcategories.length > 0;

      if (count > 0 || hasVisibleDescendants) {
        visibleNodes.push({
          ...node,
          subcategories,
        });
      }

      return visibleNodes;
    }, []);
  };

  return filterTree(categories);
};
